Vue.component('order-template', {
  props: {
    events: [],
    products: [],
    user: {
      required: true,
    },
    dietraies: [],
  },
  data: function ()
   {
    return {
      eventYear: new Date().getFullYear(),
      eventsDate: [],
      extras: [],
      totalGroupBookingUser: 0,
      usedcoupon: null,
      selectedEventId: '',
      selectedVenueId: '',
      selectedPricingId: '',
      selectedDateId: '',
      selectedproductId: '',
      dietary: null,
      donations: 0,
      couponApplied: false,
      discounted_price: '',
      venues: '',
      pricings: '',
      dates: [],
      eventPriceDetails: [],
      selectedOption: '',
      Couponcode: '',
      selectedPrice: null,
      staffCount: '',
      pricegroup: [],
      singlePrice: 0,
      type: 0,
      lastPrice: 0,
      prices: [],
      selectedStaff: [],
      selectedExtraId: [],
      pendingMembers: [],
      pendingMembersEmails: [],
      members: [],
      selectedStaffCount: 0,
      inviteStaff: false,
      isComanySetup: false,
      AttendTypeState: false,
      addingMemberDetails: false,
      staffs: [],
      company: {
        invite: {
          first_name: '',
          last_name: '',
          cell: '',
          alternative_cell: '',
          email: '',
          id_number: '',
        },
      },
      errors: {
        company: [],
        invite: [],
      },
      busy: false,
    };
  },

  watch: {
    selectedPrice: function (val, oldVal) {
      if (oldVal) {
        this.lastPrice = oldVal.discounted_new_price;
      }
      if (val) {
        if (this.prices.length == 0) {
          this.prices.push(val.discounted_new_price);
          if (this.getPriceAfterApplyCoupon(val.price) === val.discounted_new_price) {
            this.totalGroupBookingUser = 1;
          }
        } else {
          this.updatedPrices();
        }
      }
    },
    type: function (val, oldVal) {

      if (val) {
        var found = 0;
        this.totalGroupBookingUser = 0;
        for (var i = 0; i < this.members.length; i++) {
          if (this.members[i].email == this.user.email) {
            found++;
            if (this.selectedPrice && this.getPriceAfterApplyCoupon(this.selectedPrice.price) == this.selectedPrice.discounted_new_price) {
              this.totalGroupBookingUser = 1;
            }
          }
        }

        if (found == 0 && this.members.length == 0) {
          this.members.push({
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
            id_number: this.user.id_number,
            alternative_cell: this.user.alternative_cell,
            cell: this.user.cell,
          });
          this.prices = [];
          if (this.selectedPrice) {
            this.prices.push(this.selectedPrice.discounted_new_price);
          }
          if (this.selectedPrice && this.getPriceAfterApplyCoupon(this.selectedPrice.price) == this.selectedPrice.discounted_new_price) {
            this.totalGroupBookingUser = 1;
          }
          this.staffs.push(this.user.id);
        }
      }
    },
  },
  computed: {
    selectedEvent: function () {
      return this.getSelectedEvent();
    },

    selectedVenue: function () {
      if (this.selectedEventId != '') {
        return this.getSelectedVenue();
      }

    },

    selectedPricing: function () {
      return this.getSelectedPricing();
    },

    selectedProduct: function () {
      return this.getSelectedProduct();
    },

    getDiscountedPrice: function () {
      this.discounted_price = this.discount(
        this.selectedProduct.price,
        this.selectedProduct.listings[0].discount,
        this.selectedProduct.listings[0].discount_type
      );
    },

    total: function () {
      if (this.type == 1) {
        var getTotal = this.prices.reduce((item, total) => {
          return parseFloat(item) + parseFloat(total);
        }, 0);
        var totalDiscount = this.getTotalGroupBookingDiscount();
      } else {
        var getTotal = this.selectedPrice.discounted_new_price;
        var totalDiscount = 0;
      }

      var dietaryAmount = this.getTotalDiatry();
      var extras = this.getTotalExtras();
      var donation = this.getDonations();
      var total = 0;
      var total = parseFloat(getTotal) + parseFloat(extras) + parseFloat(dietaryAmount) + parseFloat(donation) - parseFloat(totalDiscount);
      if (total < 0) {
        total = 0;
      }
      return total.toFixed(2);
    },
  },

  methods: {
    SelectedOption: function (tag) {
      (this.selectedOption = tag),
        (this.selectedEventId = ''),
        (this.selectedVenueId = ''),
        (this.selectedDateId = ''),
        (this.selectedPricingId = '');
    },

    changeEventSelection: function () {
      this.selectedDateId = '';
      this.selectedVenueId = '';
      this.selectedExtraId = [];
      this.pricings = 0;
      this.venues = 0;
      this.getVenues();
      this.eventsDate = [];
      this.selectedPricingId = 0;
      this.venues = 0;
    },

    changeVenueSelection: function () {
      this.selectedDateId = this.selectedVenue.dates[0].id;
      this.getPricings();
      this.getDates();
    },

    updatedSelectedPrice: function (val) {
      this.$http
        .get('find/' + this.selectedVenueId + '/pricings')
        .then((response) => {
          this.pricings = response.data.pricings;
          this.eventPriceDetails = response.data.pricings;
          this.selectedPricingId = this.pricings[0].id;
          this.selectedPrice = this.priceDatails[0];
        });
    },

    updatedSelectedPriceDetails: function () {
      this.$http
        .get(`pricing/details/${this.selectedPricingId}`)
        .then((response) => {
          this.selectedPrice = response.data;
        });
    },

    updateSinglePrice: function (price) {
      this.singlePrice = price;
    },

    getEventById: function (id) {
      return _.find(this.events, { id: id });
    },

    getSelectedEvent: function () {
      return this.getEventById(this.selectedEventId);
    },

    getVenueById: function (id) {
      return _.find(this.selectedEvent.venues, { id: id });
    },

    getSelectedVenue: function () {
      return this.getVenueById(this.selectedVenueId);
    },

    getVenues: function () {
      this.$http
        .get('find/' + this.selectedEventId + '/venues')
        .then((response) => {
          this.venues = response.data.venues;
          this.selectedVenueId = this.venues[0].id;
          this.pricegroup = response.data.pricegroup;
          this.getPricings();
          this.getDates();
        });
    },

    getPricings: function () {
      this.$http
        .get('find/' + this.selectedVenueId + '/pricings')
        .then((response) => {
          this.pricings = response.data.pricings;
          this.eventPriceDetails = response.data.pricings;
          this.selectedPricingId = this.pricings[0].id;
          this.selectedPrice = this.pricings[0];
        });
    },

    getDates: function () {
      this.$http
        .get('find/' + this.selectedVenueId + '/dates')
        .then((response) => {
          this.eventsDate = response.data.dates;
          this.selectedDateId = this.eventsDate[0].id;
          this.dates.push(this.eventsDate[0]);
        });

    },

    getProductById: function (id) {
      return _.find(this.products, { id: id });
    },

    getSelectedProduct: function () {
      return this.getProductById(this.selectedproductId);
    },

    getPriceCalculartion(min, max, title) {
      currentPriceId = this.selectedPricingId;
      var priceDatails = _.filter(this.eventPriceDetails, function (price) {
        return price.id == currentPriceId;
      });
      var price = priceDatails[0].price;
      var discount = 0;
      var discountPrice = 0;
      var lowerprice = price;
      var i, j;
      if (max == 0) {
        max = min;
      }

      for (i = 2; i <= min; i++) {
        for (j = 0; j < this.pricegroup.length; j++) {
          if (
            i >= this.pricegroup[j].min_user &&
            i <= this.pricegroup[j].max_user
          ) {
            discount = this.pricegroup[j].discount;
            discountPrice = Math.round((lowerprice * discount) / 100);
            lowerprice = lowerprice - discountPrice;
          }
        }
      }

      for (i = 2; i <= max; i++) {
        for (j = 0; j < this.pricegroup.length; j++) {
          if (
            i >= this.pricegroup[j].min_user &&
            i <= this.pricegroup[j].max_user
          ) {
            discount = this.pricegroup[j].discount;
            discountPrice = Math.round((price * discount) / 100);
            price = price - discountPrice;
          }
        }
      }

      if (max == min) {
        return 'From ' + price + ' per person';
      }
      return 'From ' + lowerprice + ' - ' + price + ' per person';
    },

    discount: function (amount, discount, discount_type) {
      if (discount_type == 'percentage')
        return parseFloat(amount * (discount / 100));
      else return discount;
    },
    applyCouponCode: function () {
      let $cid = this.selectedEventId;
      var payload = {
        type: 'event',
        event_name: this.selectedEvent.name,
        code: this.Couponcode,
      };
      let checkCoupon = false;
      this.$http.post('/check/' + $cid, payload).then((response) => {
        if (response.data.status == 1) {
          checkCoupon = true;
          this.couponApplied = true;
          swal({
            type: 'success',
            title: 'Coupon Code',
            text: response.data.message,
          });
        } else {
          swal({
            type: 'error',
            title: 'Error',
            text: response.data.message,
          });
        }
      });
    },

    dateChanged: function () {
      var vm = this;
      var numberOfDates = vm.dates.length;
      var pricingDayCount = vm.selectedPrice.day_count;
      if (numberOfDates > pricingDayCount) {
        vm.dates = _.slice(vm.dates, 1);
      }
    },

    setMembers: function setMembers() {
      this.members = this.staff;
    },

    setSelectedStaff: function (id) {
      if (id.target.checked) {
        this.selectedStaff.push(id.target.value);
      } else {
        this.selectedStaff.splice(
          $.inArray(id.target.value, this.selectedStaff),
          1
        );
      }
      this.forms.eventSignup.staffs = this.selectedStaff;
    },

    toggleStaff() {
      if (this.inviteStaff) {
        this.inviteStaff = false;
      } else {
        this.inviteStaff = true;
      }
    },
    cancelInvite() {
      this.company.invite.first_name = '';
      this.company.invite.last_name = '';
      this.company.invite.email = '';
      this.company.invite.id_number = '';
      this.company.invite.alternative_cell = '';
      this.company.invite.cell = '';
      this.addingMemberDetails = false;
      this.inviteStaff = false;
    },
    checkInviteMember() {
      if (this.company.invite.first_name == '') {
        this.errors.invite.first_name = 'First name is required';
      }
      if (this.company.invite.last_name == '') {
        this.errors.invite.last_name = 'Last name is required';
      }
      if (this.company.invite.email == '') {
        this.errors.invite.email = 'Email is required';
      }

      if (this.company.invite.cell == '') {
        this.errors.invite.cell = 'Cell is required';
      }
      if (
        this.errors.invite.cell ||
        this.errors.invite.first_name ||
        this.errors.invite.last_name ||
        this.errors.invite.email
      ) {
        swal({
          type: 'warning',
          title: 'Fill all the fields',
        });
        this.errors.invite.cell = '';
        this.errors.invite.first_name = '';
        this.errors.invite.last_name = '';
        this.errors.invite.email = '';
        return false;
      }
      return true;
    },
    sendInvitation() {
      if (this.checkInviteMember()) {
        if (!this.pendingMembersEmails.includes(this.company.invite.email)) {
          this.pendingMembersEmails.push(this.company.invite.email);
          this.pendingMembers.push({
            first_name: this.company.invite.first_name,
            last_name: this.company.invite.last_name,
            email: this.company.invite.email,
            id_number: this.company.invite.id_number,
            alternative_cell: this.company.invite.alternative_cell,
            cell: this.company.invite.cell,
          });
          this.members.push({
            first_name: this.company.invite.first_name,
            last_name: this.company.invite.last_name,
            email: this.company.invite.email,
            id_number: this.company.invite.id_number,
            alternative_cell: this.company.invite.alternative_cell,
            cell: this.company.invite.cell,
          });
          this.staffs.push({
            first_name: this.company.invite.first_name,
            last_name: this.company.invite.last_name,
            email: this.company.invite.email,
            id_number: this.company.invite.id_number,
            alternative_cell: this.company.invite.alternative_cell,
            cell: this.company.invite.cell,
          });
          this.company.invite.first_name = '';
          this.company.invite.last_name = '';
          this.company.invite.email = '';
          this.company.invite.id_number = '';
          this.company.invite.alternative_cell = '';
          this.company.invite.cell = '';
          this.addingMemberDetails = false;
          this.prices.push(this.getPriceAfterApplyCoupon(this.selectedPrice.price));
          this.totalGroupBookingUser++;
        } else {
          swal({
            type: 'warning',
            title: 'This member is already added',
          });
        }
      }
    },
    checkAndFillMember() {
      if (this.invite_email == '' || !this.isValidEmail(this.invite_email)) {
        swal({
          type: 'warning',
          title: 'Please enter valid email',
        });
        this.invite_email = '';
        return false;
      }
      var current_email = this.invite_email;
      var exist = false;
      this.members.forEach(function callback(memberDetail, index) {
        if (memberDetail.email == current_email) {
          exist = true;
        }
      });

      if (exist) {
        swal({
          type: 'warning',
          title: 'Given Email Is Already Added',
          text: 'Try To Add Other Email',
        });
        this.inviteStaff = false;
        this.invite_email = '';
        return false;
      }

      this.$http
        .post('/checkuser', {
          email: this.invite_email,
          event_id: this.selectedEventId,
          price_id: this.selectedPricingId
        })
        .success((response) => {
          if (response.status == 'success') {
            if (response.hasTicket) {
              swal({
                type: 'warning',
                title: 'User already registered for this event',
                text: 'Try To Add Other Email',
              });
            } else {
              this.members.push(response.member);
              this.staffs.push(response.member.id);
              this.prices.push(response.member.price);
              if (this.getPriceAfterApplyCoupon(this.selectedPrice.price) == response.member.price) {
                this.totalGroupBookingUser += 1;
              }
            }
          } else {
            this.company.invite.email = this.invite_email;
            this.addingMemberDetails = true;
          }
          this.inviteStaff = false;
          this.invite_email = '';
        })
        .catch((errors) => {
          // this.errors.invite=errors.data;
        });
    },
    isValidEmail: function (email) {
      return /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(email);
    },

    removeMember: function (member) {
      var deleteIndex;
      this.members.forEach(function callback(memberDetail, index) {
        if (memberDetail.email == member.email) {
          deleteIndex = index;
        }
      });
      if (this.prices[deleteIndex] == this.getPriceAfterApplyCoupon(this.selectedPrice.price)) {
        this.totalGroupBookingUser -= 1;
      }
      this.members.splice(deleteIndex, 1);
      this.prices.splice(deleteIndex, 1);
      this.staffs.splice(deleteIndex, 1);
      this.pendingMembers.splice(deleteIndex, 1);
      this.pendingMembersEmails.splice(
        $.inArray(member.email, this.pendingMembersEmails),
        1
      );
    },

    /*
 * Calculate the total Pricings
 */
    getTotalPricing: function () {
      if (!this.selectedPrice) return 0;

      var price = this.selectedPrice.price;

      if (this.totalGroupBookingUser > 0 && this.type == 1) {
        if (
          this.pricegroup.length > 0 &&
          this.totalGroupBookingUser > 1
        ) {
          var lastPrice = price;
          var discount = 0;
          var len = this.totalGroupBookingUser;
          for (var i = 2; i <= len; i++) {
            for (var j = 0; j < this.pricegroup.length; j++) {
              if (
                i >= this.pricegroup[j].min_user &&
                i <= this.pricegroup[j].max_user
              ) {
                discount = this.pricegroup[j].discount;
                var discountPrice = Math.round((lastPrice * discount) / 100);
                lastPrice = lastPrice - discountPrice;
              }
            }
          }
          price = lastPrice;
        }
        price = price * this.totalGroupBookingUser;
      }

      if (this.type == 1 && this.totalGroupBookingUser == 0) {
        price = 0;
      }
      return price;
    },

    /*
     * Calculate the total Diatry Requirements
     */
    getTotalDiatry: function () {
      if (this.dietary != null) {
        if (this.dietary.price > 0) {
          totalDiatry = this.dietary.price;

          if (this.dates.length > 1) {
            totalDiatry = totalDiatry * this.dates.length;
          }

          if (this.staffs.length > 0 && this.type == 1) {
            totalDiatry = totalDiatry * this.staffs.length;
          }

          if (
            this.type == 1 &&
            this.staffs.length == 0
          ) {
            totalDiatry = 0;
          }

          return totalDiatry;
        } else {
          return 0;
        }
      }

      return 0;
    },

    /*
     * Calculate the total Extras
     */
    getTotalExtras: function () {
      var total = 0;
      this.extras.forEach((extra) => {
        total = parseInt(total) + parseInt(extra.price);
      });

      if (this.staffs.length > 0 && this.type == 1) {
        total = total * this.staffs.length;
      }

      if (this.type == 1 && this.staffs.length == 0) {
        total = 0;
      }

      return total;
    },

    /*
     * Calculate the donation
     */
    getDonations: function () {
      var total = 0;
      if (this.donations) {
        total = this.donations * this.staffs.length;
      }
      return total;
    },

    getTotalGroupBookingDiscount() {
      var totalDiscount = 0;
      if (!this.selectedPrice) return 0;
      var price = this.getPriceAfterApplyCoupon(this.selectedPrice.price);
      var lastPrice = price;

      if (this.totalGroupBookingUser > 0 && this.type == 1) {
        if (
          this.pricegroup.length > 0 &&
          this.totalGroupBookingUser > 1
        ) {
          var discount = 0;
          var len = this.totalGroupBookingUser;
          for (var i = 2; i <= len; i++) {
            for (var j = 0; j < this.pricegroup.length; j++) {
              if (
                i >= this.pricegroup[j].min_user &&
                i <= this.pricegroup[j].max_user
              ) {
                discount = this.pricegroup[j].discount;
                var discountPrice = lastPrice * discount / 100;
                lastPrice = lastPrice - discountPrice;
              }
            }
          }
        }
      }



      totalDiscount = parseFloat(price - lastPrice) * this.totalGroupBookingUser;
      if (this.type == 1 && this.staffs.length == 0) {
        totalDiscount = 0;
      }
      return totalDiscount.toFixed(2);
    },

    updatedPrices: function () {
      this.prices = [];
      this.totalGroupBookingUser = 0;
      this.$http
        .post('/get_price_details', {
          staffs: this.staffs,
          price_id: this.selectedPricingId,
        })
        .success((response) => {
          for (var i = 0; i < response.length; i++) {
            this.prices.push(response[i]);

            if (this.getPriceAfterApplyCoupon(this.selectedPrice.price) == response[i]) {
              this.totalGroupBookingUser += 1;
            }
          }
        })
        .catch((errors) => {
          // this.errors.invite=errors.data;
        });

    },

    getPriceAfterApplyCoupon: function (price) {
      if (
        this.usedcoupon != null &&
        this.usedcoupon != '' &&
        this.usedcoupon != undefined
      ) {
        if (this.usedcoupon.discount_type == 'percentage') {
          var disounted = price * this.usedcoupon.discount_amount / 100;
          return parseFloat(price) - parseFloat(disounted);
        } else {
          return parseFloat(price) - parseFloat(this.usedcoupon.discount_amount);
        }
      }
      return parseFloat(price);
    },



    generatePurchaseOrder: function () {

      swal({
        type: 'warning',
        title: 'Processing order',
        text:
          'Please wait while we are generating order.Do not Refresh page or close browser',
      });

      this.$http
        .post(`/admin/validate/users`, {
          selectedEventId: this.selectedEventId,
          staffs: this.staffs,
          type: 'Normal',
        })
        .success((response) => {
          if (response.data.length == 0) {
            this.$http
              .post(`/admin/member/${this.user.id}/events/register/order`, {
                selectedEventId: this.selectedEventId,
                selectedVenueId: this.selectedVenueId,
                selectedDateId: this.selectedDateId,
                selectedPricingId: this.selectedPricingId,
                staffs: this.staffs,
                dietary: this.dietary,
                selectedExtraId: this.selectedExtraId,
                donatons: this.donations,
                extras: this.extras,
                dates: this.dates.filter(
                  date => date.id === this.selectedDateId
                ),
                date_id: this.date_id,
                type: this.type,
                is_new_feature: true,
              })
              .success((response) => {
                if (response['status'] == true) {
                  this.busy = false;
                  swal.close();
                  setTimeout(() => {
                    swal({
                      type: 'success',
                      title: 'Order Generated',
                      text: "Your order generated successfully",
                    });
                    window.location = `/admin/${this.user.id}/orders`;
                  }, 2000);
                } else {
                  this.busy = false;
                  swal.close();
                  setTimeout(() => {
                    swal({
                      type: 'error',
                      title: 'Please try again',
                      text: response['message'],
                    });
                  }, 1000);
                }
              })
              .catch((errors) => {
                this.busy = false;
                swal({
                  type: 'error',
                  title: 'Error',
                  text: 'Your order has failed, please try again',
                });
              });
          } else {
            let message = response.data.join(',') + ' already registered for event';
            this.busy = false;
            swal({
              type: 'error',
              title: 'Error',
              text: message,
            });
          }
        })
        .catch((errors) => {
          this.busy = false;
          swal({
            type: 'error',
            title: 'Error',
            text: 'Your order has failed, please try again',
          });

        });
    },
    changeEventYear: function(){
      this.$http
				.get('/get_event_by_year/'+ this.eventYear)
				.success((response) => {
           
					  this.events = response;
				})
				.catch((errors) => {
					// this.errors.invite=errors.data;
				});
    },
  },
});



// WEBPACK FOOTER //
// ./resources/assets/js/orders/order.js